import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

export interface LoadingSpinnerProps {
  className?: string;
  size?: number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className, size = 24 }) => {
  return (
    <div className="flex items-center justify-center p-4">
      <Loader2 className={cn('animate-spin text-sky-400', className)} size={size} />
    </div>
  );
};
